import { Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'xsMatToolTipDisable',
    pure: false
})
export class MatSelectToolTipDisabledPipe implements PipeTransform {
  constructor() {
  }

  transform(element: any): boolean {
        const result = element.offsetWidth >= element.scrollWidth;
        return result;
  }
}
